<template>
  <v-dialog
    class="popbox"
    name="dialog2"
    v-model="isShow"
    title="参数"
    :width="800"
    @open="open"
    @after-close="handleAfterClose"
    :show-confirm="false"
    append-to-body
  >
    <v-button
      v-if="topicType === 'diy'"
      class="mb10"
      type="primary"
      name=""
      @click="openAddModel"
    >
      新增参数
    </v-button>
    <vxe-table row-id="id" :data="list" align="left">
      <vxe-table-column
        field="name"
        show-overflow
        min-width="200"
        title="字段名称"
      ></vxe-table-column>
      <vxe-table-column
        field="identifier"
        show-overflow
        min-width="200"
        title="字段标识"
      ></vxe-table-column>
      <vxe-table-column
        field="data_type_t"
        show-overflow
        min-width="200"
        title="数据类型"
      ></vxe-table-column>
      <vxe-column v-if="topicType === 'diy'" title="操作" min-width="140">
        <template v-slot="slotProps">
          <span class="handle-button"
            ><v-button
              size="S"
              type="text"
              name="btn-text1"
              slot="reference"
              @click="openUpdateModel(slotProps.row)"
              >编辑</v-button
            ></span
          >
          <span class="handle-button"
            ><v-button
              size="S"
              type="text"
              name="btn-text1"
              slot="reference"
              @click="openDelModel(slotProps.row)"
              >删除</v-button
            ></span
          >
        </template>
      </vxe-column>
    </vxe-table>
    <Params
      :showInputDialog.sync="addloading"
      :list="list"
      :row="row"
      :type="type"
      :topicId="id"
      :category="category"
      @change="getData"
    ></Params>
    <Del :showInputDialog.sync="delloading" :row="row" @change="getData"></Del>
  </v-dialog>
</template>
<script>
import Params from "@/components/product/topic-list/add-param.vue";
import Del from "@/components/product/topic-list/del-param.vue";
export default {
  components: {
    Params,
    Del,
  },
  props: {
    showInputDialog: {
      type: Boolean,
      default: false,
    },
    category: {},
    id: {},
    topicType: {},
  },
  data() {
    return {
      dataTypeOptins: [
        {
          label: "int(整数)",
          value: "int",
        },
        {
          label: "float64(浮点数)",
          value: "float64",
        },
        {
          label: "string(字符串)",
          value: "string",
        },
        {
          label: "bool(布尔值)",
          value: "bool",
        },
        {
          label: "array(数组)",
          value: "array",
        },
        {
          label: "struct(结构)",
          value: "struct",
        },
      ],
      isShow: false,
      list: [
        {
          CreatedAt: "2024-07-03T09:55:47+08:00",
          DeletedAt: null,
          ID: 34,
          UpdatedAt: "2024-07-03T09:55:47+08:00",
          category: "input",
          data_type: "string",
          identifier: "dev_key",
          name: "子设备KEY",
          topic_id: 106,
          unit: "",
        },
      ],
      addloading: false,
      delloading: false,
      type: "add",
      row: {},
    };
  },
  created() {},
  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
    },
  },
  methods: {
    open() {
      this.getData();
    },
    async getData() {
      const subData = {
        topic_id: this.id,
        category: this.category,
      };
      const res = await this.$getData(
        "/td/td-iot-api/iot/topic/param/v1",
        subData
      );
      this.list = res.data.map((item) => {
        return {
          data_type_t: this.dataTypeOptins.find(
            (type) => type.value === item.data_type
          ).label,
          ...item,
        };
      });
    },
    handleAfterClose() {
      this.$emit("update:showInputDialog", false);
    },
    openAddModel() {
      this.type = "add";
      this.addloading = !this.addloading;
    },
    openUpdateModel(row) {
      this.type = "edit";
      this.row = row;
      this.addloading = !this.addloading;
    },
    openDelModel(row) {
      this.row = row;
      this.delloading = !this.delloading;
    },
  },
};
</script>
<style lang="scss" scoped></style>

